import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingIconComponent } from './floating-icon.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { MyListInventoryComponent } from './my-list-inventory/my-list-inventory.component';
import { SharedPipesModule } from 'src/app/shared/pipe/shared-pipes.module';
import { InventoryFormDialogComponent } from './inventory-form-dialog/inventory-form-dialog.component';
import { MobileTableCardModule } from '../mobile-table-card/mobile-table-card.module';

@NgModule({
  declarations: [
    FloatingIconComponent,
    MyListInventoryComponent,
    InventoryFormDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedPipesModule,
    MobileTableCardModule,
  ],
  exports: [FloatingIconComponent],
})
export class FloatingIconModule {}
